import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import ProtectedLayout from "../layouts/ProtectedLayout";
import DefaultLayout from "../layouts/DefaultLayout";
import PublicLayout from "../layouts/PublicLayout";
// import BuilderLayout from "src/layouts/BuilderLayout";

//:- Pages to be rendered on specific endpoints
import AnalyticsLogin from "../pages/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import ReportPage from "src/pages/ReportPage";
import DashboardBuilder from "src/pages/DashboardBuilder";
import UserManagement from "src/pages/UserManagement";
import RecycleBinPage from "src/pages/RecycleBinPage";
import ChangePassword from "src/pages/ChangePassword";
import AuthHeader from "src/components/common/AuthHeader";
import BuilderHeader from "src/components/common/BuilderHeader";
import ForgotPassword from "src/pages/ForgotPassword";
import ResetPassword from "src/pages/ResetPassword";

//:- Admin portal — lazy chunk, kept out of the analytics bundle
const PortalLogin = lazy(() => import("src/pages/portal/PortalLogin"));
const PortalLayout = lazy(() => import("src/layouts/PortalLayout"));
const PortalUsersPage = lazy(() => import("src/pages/portal/UsersPage"));
const PortalClientsPage = lazy(() => import("src/pages/portal/ClientsPage"));
const PortalProgramsPage = lazy(() => import("src/pages/portal/ProgramsPage"));
const PortalTiersPage = lazy(() => import("src/pages/portal/TiersPage"));
const PortalDashboardsPage = lazy(
  () => import("src/pages/portal/DashboardsPage"),
);
const PortalKpisPage = lazy(() => import("src/pages/portal/KpisPage"));
const PortalUsagePage = lazy(() => import("src/pages/portal/UsagePage"));

export default function AnalyticsRoutes() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          {/* All Protected Routes will be placed in this group */}
          <Route element={<ProtectedLayout header={<AuthHeader />} />}>
            <Route path="/reports/:report_name" element={<ReportPage />} />
            <Route
              path="/dashboards/:dashboard_name?"
              element={<DashboardPage />}
            />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/recycle-bin" element={<RecycleBinPage />} />
            <Route path="/change-password" element={<ChangePassword />} />
          </Route>

          {/* All Protected Buider Routes will be placed in this group */}
          <Route element={<ProtectedLayout header={<BuilderHeader />} />}>
            <Route
              path="/builder/:dashboard_name?"
              element={<DashboardBuilder />}
            />
          </Route>

          <Route element={<PublicLayout />}>
            <Route path="/users/sign_in" element={<AnalyticsLogin />} />
            <Route path="/users/forgot_password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Route>

          {/* Admin portal — own login + role-gated shell */}
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route element={<PortalLayout />}>
            <Route
              path="/portal"
              element={<Navigate to="/portal/users" replace />}
            />
            <Route path="/portal/users" element={<PortalUsersPage />} />
            <Route path="/portal/clients" element={<PortalClientsPage />} />
            <Route path="/portal/programs" element={<PortalProgramsPage />} />
            <Route path="/portal/tiers" element={<PortalTiersPage />} />
            <Route
              path="/portal/dashboards"
              element={<PortalDashboardsPage />}
            />
            <Route path="/portal/kpis" element={<PortalKpisPage />} />
            {/* Usage is super_admin-only. The backend 403s regardless; the page
                also self-gates and the nav entry is hidden for other roles. */}
            <Route path="/portal/usage" element={<PortalUsagePage />} />
          </Route>

          <Route path="/" element={<DefaultLayout />} />
          <Route path="*" element={<DefaultLayout />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
